"use client"
/* */
import { ActionModel } from '../models/ActionModel.mjs';
import { useConfirmationModalButtonSlot } from './useConfirmationModalButtonSlot.mjs';

const useActionButtonState = (props) => {
  const action = ActionModel.use();
  const state = action.state.useValue();
  const isConfirmationButton = useConfirmationModalButtonSlot(props) === "primary";
  const confirmationModalIsOpen = action.confirmationModalController.useIsOpen();
  if (action.needsConfirmation && confirmationModalIsOpen && !isConfirmationButton) {
    return "isIdle";
  }
  return state;
};

export { useActionButtonState };
//# sourceMappingURL=useActionButtonState.mjs.map
